import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { FullPageLoader } from "@/components/ds";
import AppLayout from "@/layouts/AppLayout";

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, mfaEnrollmentRequired } = useAuth();
  const location = useLocation();
  if (user === null) return <FullPageLoader />;
  if (user === false) return <Navigate to="/login" replace />;
  if (mfaEnrollmentRequired && location.pathname !== "/mfa-setup") {
    return <Navigate to="/mfa-setup" replace />;
  }
  return <AppLayout>{children}</AppLayout>;
}
